module.exports = __webpack_public_path__ + "static/media/controle-screen.24a5ae27.png";